import storage from 'viralstyle-ui/src/storage';

import config from 'config';

class Logger {
  constructor() {
    let forceDebug = storage.get('debug-pixels');

    this.debug = config.ENVIRONMENT !== 'Production' || forceDebug;
  }

  group(title) {
    if (this.debug) console.group(title);
  }

  groupCollapsed(title) {
    if (this.debug) console.groupCollapsed(title);
  }

  table(obj) {
    if (this.debug) console.table(obj);
  }

  groupEnd() {
    if (this.debug) console.groupEnd();
  }

  log(message) {
    if (this.debug) console.log(message);
  }

  checkRetargeting(disabled) {
    if (disabled) {
      this.log('VS retargeting is disabled.')
      return false;
    } else {
      return true;
    }
  }

  checkCampaign(id) {
    if (id) {
      return true;
    } else {
      this.log('Campaign specific not configured.');
      return false;
    }
  }

  checkGlobal(id, campaignId) {
    if (id && id !== campaignId) {
      return true;
    } else if (id && id === campaignId) {
      this.log('Global is the same as campaign specific.');
      return false;
    } else {
      this.log('Global not configured.');
      return false;
    }
  }
};

export default new Logger();